/**
 * @file share.js
 * SDC Component: Share
 *
 * Handles share popup toggle with outside click + Escape close.
 * Works for any number of share components on the page.
 */

(function (Drupal, once) {
  'use strict';

  function initSharePopup(component) {
    var toggle = component.querySelector('.js-share-toggle');
    var popup = component.querySelector('.js-share-popup');
    if (!toggle || !popup) return;

    function openPopup() {
      popup.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      popup.setAttribute('tabindex', '-1');
      popup.focus();
      document.addEventListener('click', onOutsideClick);
    }

    function closePopup() {
      popup.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      toggle.focus();
      document.removeEventListener('click', onOutsideClick);
    }

    function isOpen() {
      return !popup.hidden;
    }

    function onOutsideClick(e) {
      if (!popup.contains(e.target) && e.target !== toggle) {
        closePopup();
      }
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      isOpen() ? closePopup() : openPopup();
    });

    document.addEventListener('keydown', function (e) {
      if (isOpen() && e.key === 'Escape') {
        closePopup();
      }
    });
  }

  Drupal.behaviors.share = {
    attach: function attach(context) {
      once('share', context.querySelectorAll('.share')).forEach(function (component) {
        initSharePopup(component);
      });
    }
  };
})(Drupal, once);
